
import { EventEmitter, Injectable, Output } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AccountingConfigurationComponent } from 'src/app/shared/modals/accounting-configuration/accounting-configuration.component';
import { AccountingConfigurationsModel } from '../../models/accounting/account-settings.model';
import { Subscription } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AccountingConfigurationModalService {

    @Output() modelChanged = new EventEmitter<any>();

    constructor(private modalService: NgbModal) { }

    openModal(inputModel: AccountingConfigurationsModel, index:  number | undefined) {
        var modalRef!: NgbModalRef;
        modalRef = this.modalService.open(AccountingConfigurationComponent, { windowClass: "customModalClassUnderName", size: 'lg', centered: false, backdrop: 'static', keyboard: false });
       
        modalRef.componentInstance.inputModel = inputModel;
        modalRef.componentInstance.modelIndex = index;

        var sub: Subscription = modalRef.componentInstance.modelChanged.subscribe(() => {
            if (modalRef.componentInstance.accountingConfigurationsModel) {
                this.modelChanged.emit(modalRef.componentInstance.accountingConfigurationsModel);
            }
            sub.unsubscribe();
        })
    }
}
